import { useState, useEffect } from 'react';

const navItems = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Products', href: '#products' },
  { label: 'Features', href: '#features' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur-md border-b border-stone-100 shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
        <span
          className={`font-semibold text-lg tracking-tight cursor-pointer transition-colors duration-300 ${
            scrolled ? 'text-stone-900' : 'text-white'
          }`}
          onClick={() => handleNav('#home')}
        >
          TUL d.o.o.
        </span>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <button
              key={item.label}
              onClick={() => handleNav(item.href)}
              className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap hover:opacity-70 ${
                scrolled ? 'text-stone-700' : 'text-white/90'
              }`}
            >
              {item.label}
            </button>
          ))}
        </nav>

        {/* Mobile hamburger */}
        <button
          className={`md:hidden flex flex-col gap-1.5 cursor-pointer p-1 ${scrolled ? 'text-stone-900' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`block w-6 h-0.5 transition-all duration-200 ${scrolled ? 'bg-stone-900' : 'bg-white'}`} />
          <span className={`block w-6 h-0.5 transition-all duration-200 ${scrolled ? 'bg-stone-900' : 'bg-white'}`} />
          <span className={`block w-6 h-0.5 transition-all duration-200 ${scrolled ? 'bg-stone-900' : 'bg-white'}`} />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-stone-100 px-6 py-4 flex flex-col gap-4">
          {navItems.map((item) => (
            <button
              key={item.label}
              onClick={() => handleNav(item.href)}
              className="text-stone-700 text-sm font-medium text-left cursor-pointer hover:text-stone-900 whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}
